// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","container":"container_container__ySS4B"};